module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="base-league-data" >\n	<div class="table-item avatar">\n		<picture>\n			<source srcset="'+
((__t=( avatar ))==null?'':_.escape(__t))+
'" class="js-display-img" type="image/png">\n			<img src="/assets/images/test-avatar.png?v=1" alt="League avatar">\n		</picture>\n	</div>\n	<div class="table-item name">\n		<div class="league-name">\n			'+
((__t=( name ))==null?'':_.escape(__t))+
'\n		</div>\n	</div>\n	<div class="table-item size"></div>\n	<div class="table-item button">\n		<a href="/comps/'+
((__t=( id ))==null?'':_.escape(__t))+
'/regenerate" class="secondary-btn">Regenerate</a>\n	</div>\n</div>\n\n\n';
}
return __p;
};
